<template>
    <div class="box">
      <div>
        <el-form :inline="true" :model="searchForm" ref="searchForm" size="mini" @submit.native.prevent>
          <el-form-item label="车牌号码" prop="carNumber">
            <el-autocomplete
              popper-class="my-autocomplete"
              :fetch-suggestions="queryCar"
              placeholder="请输入车牌号码"
              @select="handleSelectCar"
              v-model="searchForm.carNumber"
              :trigger-on-focus="false"
            >
              <template slot-scope="{ item }">
                <div class="name" v-if="item.count >0" ><i style="color: #d53131">{{ item.carNumber }}--自己上车</i>&nbsp;{{item.title}}</div>
                <div class="name" v-else>{{ item.carNumber }}&nbsp;{{item.title}}</div>
              </template>
            </el-autocomplete>
          </el-form-item>
          <el-button size="mini" type="primary" @click="search" icon="el-icon-search" :loading="loading">搜索</el-button>
        </el-form>
      </div>
      <div>
        <el-table
          v-loading="loading"
          :data="carList.records"
          :row-class-name="blackList"
          stripe
          :height="windowHeight"
          style="width: 100%;z-index: 1;font-size: 12px">
          <el-table-column
            prop="carNumber"
            label="车牌号码"
            label-class-name="header">
          </el-table-column>
          <el-table-column
            prop="driverName"
            label="姓名"
            label-class-name="header">
          </el-table-column>
          <el-table-column
            prop="driverPhone"
            label="电话"
            label-class-name="header">
          </el-table-column>
          <el-table-column
            prop="driverAddress"
            label="地址"
            label-class-name="header">
          </el-table-column>
        </el-table>
      </div>
      <div style="margin-top: 10px">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="carList.current"
          :page-sizes="[15, 30, 50, 100]"
          :page-size="carList.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="carList.total">
        </el-pagination>
      </div>
    </div>
</template>

<script>
import {getCarForNumber, carListByApp} from '../../../api/car'
export default {
  data: function () {
    return {
      searchForm: {
        carNumber: '',
        appId: '',
        pageSize: 15,
        current: 1
      },
      carList: [],
      windowHeight: '',
      loading: false
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.searchForm.appId = to.params.id
      vm.search()
    })
  },
  created () {
    this.windowHeight = document.documentElement.offsetHeight - 310
  },
  methods: {
    handleSizeChange (val) {
      this.searchForm.pageSize = val
      this.search()
    },
    handleCurrentChange (val) {
      this.searchForm.current = val
      this.search()
    },
    queryCar (queryString, cb) {
      this.searchForm.carId = ''
      getCarForNumber(queryString, this.searchForm.appId).then((response) => {
        if (response.data.data.records.length > 0) {
          let map = new Map()
          let arr = []
          response.data.data.records.forEach((element) => {
            map.set(element.carId, {carNum: element.carNumber, count: element.count})
          })
          map.forEach((value, key) => {
            arr.push({carId: key, carNumber: value.carNum, count: value.count})
          })
          cb(arr)
        } else {
          // eslint-disable-next-line
          cb([{
            carNumber: '',
            name: '',
            title: '没有匹配到车牌号'
          }])
        }
      })
    },
    handleSelectCar (item) {
      this.searchForm.carId = item.carId
      this.searchForm.carNumber = item.carNumber
    },
    blackList ({row}) {
      if (row.count > 3) {
        return 'blackListPush'
      } else if (row.count > 0) {
        return 'blackList'
      }
      return ''
    },
    search () {
      this.searchForm.current = 1
      this.loading = true
      let _this = this
      carListByApp(this.searchForm).then((response) => {
        _this.carList = response.data.data
        setTimeout(() => {
          _this.loading = false
        }, 1000)
      }).catch(() => {
        _this.loading = true
      })
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
  .blackList
    color #e86a6a
  .blackListPush
    color red
  .el-autocomplete-suggestion
    li
      line-height: normal !important
      padding: 7px !important
  .box
    padding 18px
    background #fff;
    border-radius 5px
    font-size 12px
    transition .3s
    box-shadow 0 0 8px 0 rgba(156, 156, 156, 0.6), 0 2px 4px 0 rgba(232, 237, 250, 0.5)
  .my-autocomplete
    .autoPhone
      text-overflow: ellipsis
      overflow: hidden
    .autoName
      font-size: 12px
      color: #b4b4b4
</style>
